<template>
  <SogCard>
    <SogCardTitle>
      {{ insurance?.insuranceNumber }}
    </SogCardTitle>
    <slot />
    <SogCardContent v-show="!skeletonVisible">
      <InsuranceHeadComponent :insurance="insurance" />
    </SogCardContent>
    <SogCardContent>
      <SogSkeleton v-show="skeletonVisible" />
    </SogCardContent>
  </SogCard>
</template>
<script setup lang="ts">


import Insurance from "@/shared/model/Insurance";
import InsuranceHeadComponent from "@/modules/Insurance/components/InsuranceComponent.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogSkeleton from "@/shared/ui/SogSkeleton.vue";

interface Props {
  insurance?: Insurance
  skeletonVisible?: boolean
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
    insurance: undefined,
    skeletonVisible: false
  }
)
</script>


<style scoped>

</style>
